export default __webpack_public_path__ + "static/media/pic1.ab921a63.png";